import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Box from '@material-ui/core/Box';
import Button from 'components/common/Button';
import img from '../../../assets/referral/modal.jpg';
import Modal from 'components/ui/modal';
import ReferralCard from './ReferralCard';

const styles = (theme) => ({
  img: {
    objectFit: 'contain',
    height: '100%',
    position: 'absolute',
    left: '15%',
    top: '50%',
    transform: 'translate(-50%,-50%)',
    [theme.breakpoints.down(800)]: {
      display: 'none',
    },
  },
  imgcontainer: {
    overflow: 'hidden',
  },
  modal: {
    padding: 0,
    paddingTop: '0!important',
  },
  content: {
    overflow: 'hidden',
    padding: '0px',
    marginLeft: '35%',
    // paddingTop: '10%',
    [theme.breakpoints.down(800)]: {
      margin: 'auto',
      height: '60%',
      overflow: 'auto',
    },
  },
  close: {
    position: 'absolute',
    right: 0,
    top: 0,
  },
  container: {
    '& > :nth-child(3) > div': {
      width: 800,
      maxWidth: 800,
      borderRadius: 0,
      [theme.breakpoints.down(800)]: {
        height: '60%',
      },
    },
  },
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: 0,
    paddingTop: 0,
  },
}))(MuiDialogContent);

const NewAddInviteModal = ({
  onClose,
  onSubmit,
  classes,
  referral
}) => {

  const [style, setStyle] = useState('referral_popup')

  return (
    <>
      <Modal
        fullWidth
        open
        maxWidth="sm"
        className={classes.container}
      >
        <DialogContent className={classes.modal}>
          <IconButton className={classes.close} onClick={onClose}>
            <CloseIcon />
          </IconButton>
          <Box>
            <Grid>
              <Grid className={classes.imgcontainer}>
                <img src={img} className={classes.img} alt=" " />
              </Grid>

              <Grid item xs={8} className={classes.content}>
                <ReferralCard style={style} referral={referral} onSubmit={onSubmit} />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
      </Modal>
    </>
  );
};

export default withStyles(styles)(NewAddInviteModal);
